import React from "react";
import {
    Box,
} from '@material-ui/core';

import { useCalculator } from '../../../state/calculatorState';
import { compileNotes } from '../../../utils/utils';



export const GetSummaryNotes = () => {
    const [calculator,] = useCalculator();
    const notes = compileNotes(calculator)
    return notes
}


export const SummaryNotes = () => {
    const [calculator,] = useCalculator();
    const notes = compileNotes(calculator)
    const htmlNotes = notes.join("<br />");

    return (
        <Box >
            <Box display="flex" flexGrow={1} style={{ paddingBottom:20, flexDirection:"row", fontSize:11}}>
                <div dangerouslySetInnerHTML={{ __html: htmlNotes }} />
            </Box>
        </Box>
    );
}
